import axios, { AxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios'
import { TokenInfoService } from '@/services/auth/common/tokenInfo'
import env from '@/services/environment'

export default class Xhr {
  private axios: AxiosInstance

  private constructor (axios: AxiosInstance) {
    this.axios = axios
    this.axios.interceptors.request.use(
      function (config) {
        // const user = store.getters['user/getUser'] as User
        if (config.url !== 'auth/token' && config.url !== 'auth/renewtoken') {
          const accessInfo = TokenInfoService.tokenData()
          if (accessInfo) {
            const base64Url = accessInfo.accessToken.split('.')[1]
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            const jsonToken = JSON.parse(window.atob(base64))
            if (jsonToken) {
              const encode = btoa(jsonToken?.sub) || ''
              const encodedUsername = encode?.replace(/c/g, '_').replace(/V/g, '-') || encode
              config.headers.Username = encodedUsername // Encoded Username
              config.headers.Authorization = 'Bearer ' + accessInfo.accessToken
            }
          }
          return config
        } else {
          const envCheck = env.getEnvVariable('VUE_APP_ROOT_API')
          if (envCheck.includes('localhost:') || envCheck.includes('ui-dev')) {
            const splitBaseURL = config.baseURL.replace('/v1/', '/')
            config.baseURL = splitBaseURL
          } else {
            const updateURL = `security/${config.url}`
            config.url = updateURL
          }
          config.headers['Access-Control-Allow-Origin'] = '*'
          config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS'
          config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token'
          // config.withCredentials = true  // this is causing CORS issue. The value of the 'Access-Control-Allow-Origin' header in the response must not be the wildcard '*' when the request's credentials mode is 'include'
          console.log(config)
          return config
        }
      }, function (err) {
        return Promise.reject(err)
      })

    // this.axios.interceptors.response.use(
    //   (res) => {
    //     console.log('buildExpirationDate--- ', TokenInfoService.buildExpirationDate())
    //     return res
    //   },
    //   async (err) => {
    //     const originalConfig = err.config

    //         const tokenData = TokenInfoService.tokenData()
    //         await getRefreshToken(tokenData?.refreshToken).then((response) => {
    //           if (response.status === 200) {
    //             store.dispatch('ui/hideMask')
    //             const token = response.content
    //             const accessInfo = {
    //               code: '',
    //               accessToken: token.idToken,
    //               refreshToken: token?.refreshToken
    //             }
    //             console.log('refresh accessInfo received')
    //             TokenInfoService.updateAccessToken(accessInfo)
    //             store.dispatch('ui/hideMask')
    //             return this.axios(originalConfig)
    //           }
    //         }).catch(error => {
    //           console.log(error)
    //           store.dispatch('ui/hideMask')
    //         })
    //       }
    //     }
    //     return Promise.reject(err)
    //   }
    // )
  }

  get<R> (url: string, opts?: AxiosRequestConfig): Promise<AxiosResponse<R>> {
    return this.axios.get(url, opts)
  }

  post<D, R> (url: string, data: D, opts?: AxiosRequestConfig): Promise<AxiosResponse<R>> {
    return this.axios.post(url, data, opts)
  }

  put<D, R> (url: string, data: D, opts?: AxiosRequestConfig): Promise<AxiosResponse<R>> {
    return this.axios.put(url, data, opts)
  }

  patch<D, R> (url: string, data: D, opts?: AxiosRequestConfig): Promise<AxiosResponse<R>> {
    return this.axios.patch(url, data, opts)
  }

  delete<R> (url: string, opts?: AxiosRequestConfig): Promise<AxiosResponse<R>> {
    return this.axios.delete(url, opts)
  }

  getAxios (): AxiosInstance {
    return this.axios
  }

  static builder () {
    return new this.Builder()
  }

  private static Builder = class XhrBuilder {
    private xhrConfig: any = {};

    build (): Xhr {
      const axiosInstance = axios.create(this.xhrConfig)
      return new Xhr(axiosInstance)
    }

    setBaseUrl (baseURL: string) {
      this.xhrConfig.baseURL = baseURL
      return this
    }

    setHeaders (headers: object) {
      this.xhrConfig.headers = headers
      return this
    }

    setTimeout (time: number) {
      this.xhrConfig.timeout = time
      return this
    }
  }
}
